/**
 * Scroll-in animations (vanilla JS).
 * - .os-animation — default delay 0.5s
 * - .os-animation2 — default delay 0.7s
 * Optional: data-os-animation, data-os-animation-delay, data-os-root-margin (override defaults)
 * Primary: IntersectionObserver. Fallback: Waypoints 4 (load waypoints.min.js before this file).
 */
(function () {
  'use strict';

  var DEFAULT_ANIMATION = 'fadeInUp';
  var DEFAULT_DELAY = '0.5s';
  var DEFAULT_DELAY_2 = '0.8s';
  var DEFAULT_ROOT_MARGIN = '0px';

  function setDelays(el, delay) {
    el.style.setProperty('-webkit-animation-delay', delay);
    el.style.setProperty('-moz-animation-delay', delay);
    el.style.setProperty('animation-delay', delay);
  }

  function applyAnimation(el, osAnimationClass) {
    el.classList.add('animated', osAnimationClass);
  }

  function bindReveal(el, onVisible) {
    if (!el) return;

    var margin = el.getAttribute('data-os-root-margin') || DEFAULT_ROOT_MARGIN;

    if (typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            onVisible();
            io.unobserve(entry.target);
          });
        },
        {
          root: null,
          rootMargin: margin,
          threshold: 0,
        }
      );
      io.observe(el);
      return;
    }

    if (typeof Waypoint === 'undefined') {
      onVisible();
      return;
    }

    new Waypoint({
      element: el,
      handler: function () {
        onVisible();
        this.destroy();
      },
      offset: 'bottom-in-view',
    });
  }

  /**
   * @param {ParentNode} root
   * @param {string} classSelector - e.g. '.os-animation' or '.os-animation2'
   * @param {string} boundAttr - attribute name to mark bound nodes (e.g. 'data-os-bound')
   * @param {string} defaultDelay - used when data-os-animation-delay is absent
   */
  function initOsAnimations(root, classSelector, boundAttr, defaultDelay) {
    root = root || document;
    var list = root.querySelectorAll(
      classSelector + ':not([' + boundAttr + '])'
    );

    list.forEach(function (el) {
      el.setAttribute(boundAttr, '');
      var osAnimationClass =
        el.getAttribute('data-os-animation') || DEFAULT_ANIMATION;
      var osAnimationDelay =
        el.getAttribute('data-os-animation-delay') || defaultDelay;
      setDelays(el, osAnimationDelay);
      bindReveal(el, function () {
        applyAnimation(el, osAnimationClass);
      });
    });
  }

  function runInits(root) {
    initOsAnimations(root, '.os-animation', 'data-os-bound', DEFAULT_DELAY);
    initOsAnimations(
      root,
      '.os-animation2',
      'data-os2-bound',
      DEFAULT_DELAY_2
    );
  }

  function onReady() {
    runInits(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target;
    if (root && typeof root.querySelectorAll === 'function') {
      runInits(root);
      return;
    }
    if (ev.detail && ev.detail.sectionId) {
      var sec = document.getElementById('shopify-section-' + ev.detail.sectionId);
      if (sec) runInits(sec);
    }
  });
})();
